import buildCJAPageViewPayload from 'yoda-core-components/lib/helpers/Analytics/CJAPageViewBuilder';
import { buildProductData } from 'yoda-core-components/lib/helpers/Analytics/CJAProductBuilder';
import { mapProductFromState, filterToSelectedLot } from 'yoda-mini-pdp/lib/helpers/CjaHelper';

export const buildPageViewPayload = (state) => {
    const productDetails = state.productDetails || {};
    const breadcrumbs = productDetails?.breadCrumbInfo?.breadcrumbs || [];
    const shopTheLook = state.shopTheLook || {};

    return buildCJAPageViewPayload(
        {
            name: `${productDetails.name || ''}`.toLowerCase(),
            type: 'pdp',
            breadcrumbs: breadcrumbs
                .map((b) => b.breadCrumbLabel || '')
                .join('>')
                .toLowerCase(),
            siteSection: breadcrumbs[1]?.breadCrumbLabel || '',
            category: {
                primary: breadcrumbs[1]?.breadCrumbLabel || '',
                sub1: breadcrumbs[2]?.breadCrumbLabel || '',
                sub2: breadcrumbs[3]?.breadCrumbLabel || '',
            },
            flags: {
                isErrorPage: !!state.ErrorPage,
                isChatAvailable: true,
                isShopTheLookModule: !!(
                    shopTheLook.productPrices && shopTheLook.productPrices.length
                ),
            },
            tech: {
                releaseVersion: (state.context || {}).__RELEASEVERSION__ || '',
                version: `apollo 1 pdp - ${productDetails.templateType || 'standard'}`,
            },
        },
        {},
        {
            interactionName: 'product_view',
            products: buildProductData([mapProductFromState(state)]),
        }
    );
};

export const buildSelectOptionsPDPPayload = (state, payload) => {
    const mapped = mapProductFromState(state);
    const selectedLot = filterToSelectedLot(mapped);

    return {
        event: 'selectoptionspdp',
        event_name: 'selectoptionspdp',
        interactionName: 'product_view',
        products: buildProductData([
            {
                ...mapped,
                ...selectedLot,
                lotId: selectedLot.lotId.length
                    ? selectedLot.lotId
                    : payload.productLotId || mapped.lotId,
                inventoryStatus:
                    mapped.inventoryStatus === 'in stock' ? 'in_stock' : 'out_of_stock',
            },
        ]),
    };
};

export const buildSaveProductPayload = (actionPayload) => {
    const productInfo = (actionPayload?.product || [])[0]?.productInfo || {};
    return {
        event: 'save_product',
        event_name: 'save_product',
        products: buildProductData([
            {
                id: productInfo.productPPID || '',
                name: (productInfo.productName || '').toLowerCase(),
                imgSource: productInfo.productImageSrc || '',
                link: productInfo.productLink || '',
                sellerName: productInfo.mpSellername || '',
                sellerType: productInfo.productSellertype || '',
            },
        ]),
    };
};
